module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_6000.80de760a.png";